import messages from '../scripts/frontend-messages';
import userLoggedIn from '../scripts/user-logged-in';
import Modal from "../scripts/modal";
import Cookies from 'js-cookie'
import SiteMessagesInstance from '../components/site-messages'
import { safeNext } from '../scripts/return-to';
import { setupHtml, codeField, recoveryCodesHtml, bindRecoveryCodes } from '../components/two-factor';

// (not single sign-on's way back, templates/sso.php, which looks the same)
const userLoginContainer = document.querySelector('.user-login-container:not(.sso-callback)');

if(userLoginContainer) {

  const form = userLoginContainer.querySelector('.user-login-form');
  const formContainer = userLoginContainer.querySelector('.user-login__form');
  const btn = userLoginContainer.querySelector('.login-button');

  let token = window.localStorage.getItem('token');

  if(!token) {
    token = Cookies.get('token');
  }

  // back to the page that asked for a login (next=), else the Dashboard
  const next = safeNext(new URLSearchParams(window.location.search).get('next'));
  let redirect_url = window.site.home + (next || '/dashboard');

  if(userLoginContainer.dataset.redirect) {
    switch (userLoginContainer.dataset.redirect) {
      case('onboarding'):
        redirect_url = window.site.home + '/setup';
        break;
    }
  }

  if(token) {
    window.location.href = redirect_url;
  } else {
    $(userLoginContainer).show();
  }

  let isShowingPassword = false;
  const $passwordInput = $(form).find('input[name="password"]');
  const $showHidePassword = $(form).find('.user-login-show-hide-password');

  const toggleShowHidePassword = () => {

    isShowingPassword = !isShowingPassword;
    $showHidePassword.toggleClass('is-active', isShowingPassword);

    if(isShowingPassword) {
      $passwordInput[0].type = 'text';
      $showHidePassword.html('<i class="fas fa-eye"></i>');
    } else {
      $passwordInput[0].type= 'password';
      $showHidePassword.html('<i class="fas fa-eye-slash"></i>');
    }

  }

  $showHidePassword.on('click', toggleShowHidePassword);

  const signedIn = data => {

    window.loginSession = data;

    window.localStorage.setItem('token', data.token);
    Cookies.set('token', encodeURIComponent(data.token), { expires: 365 });

    window.location.href = redirect_url;

  };

  // a POST to the API like the sign-in's own, answering its envelope
  const post = (path, data) => new Promise(resolve => {
    $.ajax({
      url: window.site.api + path,
      type: 'post',
      data,
      dataType: 'json',
      success: resolve,
      error: () => resolve({ type: 'error', message: 'You might not be connected to the internet. Please try again.' }),
    });
  });

  // the sign-in's second step, in place of the form: the code, or the setup
  const twoFactorStep = ({ two_factor: step, ticket }) => {

    $(form).hide();
    const $step = $('<div class="two-factor-step" style="text-align: center;"></div>').appendTo(formContainer);

    const back = () => {
      $step.remove();
      $(form).show();
      $(form).find('[name="password"]').val('').trigger('focus');
    };

    const failed = r => {
      SiteMessagesInstance.addMessage('error', r.message);
      SiteMessagesInstance.displayMessages();
      if (r.data && r.data.reason === 'ticket') back();
    };

    const backLink = `<p style="margin-top: 14px;"><button type="button" class="user-login__form__forgot-password" data-action="two_factor_back">Back to sign in</button></p>`;
    $step.on('click', '[data-action="two_factor_back"]', back);

    // signed in: a used recovery code says how many are left first
    const done = data => {
      if (data.recovery_left === undefined) {
        signedIn(data);
        return;
      }
      $step.html(`
        <h2 class="user-login-heading">Signed in with a recovery code</h2>
        <p>You have ${data.recovery_left} recovery code${data.recovery_left === 1 ? '' : 's'} left. Make new ones in Settings › Two-Factor.</p>
        <button type="button" class="button button--medium button--black" data-action="two_factor_continue">Continue</button>
      `);
      $step.one('click', '[data-action="two_factor_continue"]', () => signedIn(data));
    };

    // the login's own code, or for a Temp Stick admin password the code from
    // the support login's authenticator
    if (step === 'code' || step === 'master') {

      $step.html(`
        <form class="two-factor-form">
          <h2 class="user-login-heading">${step === 'master' ? 'Temp Stick admin sign-in' : 'Two-factor sign-in'}</h2>
          <p>${step === 'master' ? 'Enter the code from the Temp Stick support authenticator.' : 'Enter the six-digit code from your authenticator app.'}</p>
          ${codeField()}
          ${step === 'master' ? '' : '<p style="font-size: 13px; color: #666; margin-top: 8px;">Lost your phone? Enter one of your recovery codes instead.</p>'}
          <button type="submit" class="button button--medium button--black small-only-expanded">Verify</button>
          ${backLink}
        </form>
      `);
      $step.find('input[name="code"]').trigger('focus');

      $step.on('submit', 'form', async e => {
        e.preventDefault();
        const $submit = $step.find('button[type="submit"]').prop('disabled', true);
        const r = await post('/login/two-factor', { ticket, code: $step.find('input[name="code"]').val() });
        $submit.prop('disabled', false);
        if (r.type === 'success') done(r.data); else failed(r);
      });

      return;
    }

    // the team requires it: set it up here, then sign in
    $step.html(`
      <h2 class="user-login-heading">Set up two-factor sign-in</h2>
      <p>Your team requires a code from an authenticator app when you sign in.</p>
      <div class="two-factor-setup loading-overlay" style="min-height: 220px;"></div>
      ${backLink}
    `);

    post('/login/two-factor/setup', { ticket }).then(r => {
      if (r.type !== 'success') {
        failed(r);
        return;
      }
      $step.find('.two-factor-setup').removeClass('loading-overlay').html(`
        <form class="two-factor-form">
          ${setupHtml(r.data)}
          ${codeField()}
          <p style="margin-top: 12px;"><button type="submit" class="button button--medium button--black small-only-expanded">Turn on and sign in</button></p>
        </form>
      `);
      $step.find('input[name="code"]').trigger('focus');
    });

    $step.on('submit', 'form', async e => {
      e.preventDefault();
      const $submit = $step.find('button[type="submit"]').prop('disabled', true);
      const r = await post('/login/two-factor/enable', { ticket, code: $step.find('input[name="code"]').val() });
      $submit.prop('disabled', false);
      if (r.type !== 'success') {
        failed(r);
        return;
      }
      // the recovery codes, once, before going on
      $step.html(`
        <h2 class="user-login-heading">Two-factor sign-in is on</h2>
        ${recoveryCodesHtml(r.data.recovery_codes)}
        <p style="margin-top: 16px;"><button type="button" class="button button--medium button--black" data-action="two_factor_continue">I saved them, continue</button></p>
      `);
      bindRecoveryCodes($step, r.data.recovery_codes);
      $step.one('click', '[data-action="two_factor_continue"]', () => signedIn(r.data));
    });

  };

  // single sign-on (ssosrv): a team on it signs in through its identity
  // provider. The email's domain says which (tempstickapi GET /sso/discover).
  const $sso = $(`<p class="user-login-sso" style="text-align: center; margin: 16px 0 0;">
      <button type="button" class="user-login__form__forgot-password" data-action="sign_in_with_sso">Sign in with SSO</button>
    </p>`).appendTo(form);

  const startSso = () => {
    const email = String($(form).find('[name="email"]').val() || '').trim();
    if (!email) {
      SiteMessagesInstance.addMessage('error', 'Enter your work email, then choose Sign in with SSO.');
      SiteMessagesInstance.displayMessages();
      return;
    }
    $(formContainer).toggleClass('loading-overlay', true);
    $.ajax({
      url: window.site.api + '/sso/discover',
      type: 'get',
      data: { email },
      dataType: 'json',
      success: r => {
        if (r.type === 'success' && r.data && r.data.sso) {
          const back = window.site.home + '/sso' + (next ? '?next=' + encodeURIComponent(next) : '');
          window.location.href = r.data.url + '&return_to=' + encodeURIComponent(back);
          return;
        }
        $(formContainer).toggleClass('loading-overlay', false);
        SiteMessagesInstance.addMessage('error', "Single sign-on isn't set up for that email's domain. Sign in with your password.");
        SiteMessagesInstance.displayMessages();
      },
      error: () => {
        $(formContainer).toggleClass('loading-overlay', false);
        messages.showError('You might not be connected to the internet or a firewall is blocking the connection');
      },
    });
  };

  $sso.on('click', '[data-action="sign_in_with_sso"]', startSso);

  $(form).on('submit', e => {

    e.preventDefault();

    $(formContainer).toggleClass('loading-overlay', true);
    $(btn).attr('disabled', true);

    const remember_me = $(form).find('[name="remember_me"]').is(':checked') ? 1 : 0;
    const username = $(form).find('[name="email"]').val();

    $.ajax({
      url: window.site.api + '/login',
      type: 'post',
      data: {
        username,
        password: $(form).find('[name="password"]').val(),
        remember_me,
      },
      dataType: 'json',
      success: r => {
        if (r.type === 'success') {

          // the authenticator app's code first (or setting it up, when the
          // team requires it): the API answers a ticket, no token yet
          if (r.data.two_factor) {
            $(formContainer).toggleClass('loading-overlay', false);
            $(btn).removeAttr('disabled');
            twoFactorStep(r.data);
            return;
          }

          signedIn(r.data);

        } else {

          console.log(r);

          SiteMessagesInstance.addMessage("error", r.message);
          SiteMessagesInstance.displayMessages();

          $(formContainer).toggleClass('loading-overlay', false);
          $(btn).removeAttr('disabled');

          // the team signs in with single sign-on: on to it
          if (r.data && r.data.reason === 'sso_required') {
            startSso();
          }

        }
      },
      error: (xhr, textStatus, errorThrown) => {

        messages.showError(`
          You might not be connected to the internet or a firewall is blocking the connection<br>
          Call customer support at <b>888.263.6973</b>`
        );

        $(formContainer).toggleClass('loading-overlay', false);
        $(btn).removeAttr('disabled');

      },
    });

  });

  $('.new-user-button').on('click', () => {

    const modal = new Modal({
      class: ['modal'],
      title: 'Create Account',
    });

    modal.setContent(`

      <p>Create a new Temp Stick account to view your sensor data</p>
      <form data-for="create-account" method="post">
        <div class="setting">
          <div class="setting__label">Email</div>
          <input type="email" name="email" placeholder="youremail@mail.com" required />
        </div>
        <div class="setting">
          <div class="setting__label">Password</div>
          <input type="password" name="password" required />
        </div>
        
        <div class="setting-save">
          <div class="setting-save__button">
            <button type="submit" class="button button--blue">Create Account</button>
          </div>
          <div class="setting-save__message"></div>
        </div>
  
      </form>
      
    `);

    const container = modal.getContainer();
    const $form = $(container).find('form[data-for="create-account"]');

    $form.on('submit', e => {

      e.preventDefault();

      const $btn = $form.find('setting-save__button');
      const $message = $form.find('.setting-save__message');

      $btn.attr('disabled', true);
      $message.html('Creating account...');

      window.apiRequestNoToken('post', '/user/create', $form.serialize()).then(r => {

        setTimeout(() => {

          if(r.type === 'success') {
            SiteMessagesInstance.addMessage('success', 'Successfully created your account, you may log in now');
            SiteMessagesInstance.displayMessages();
            modal.close();
          } else {
            $message.html(r.message);
          }

        }, 200);

      });

    });

    modal.open();

  });

  $('.forgot-password-button').on('click', () => {

    const modal = new Modal({
      class: ['modal'],
      title: 'Forgot Password',
    });

    modal.setContent(`
    <form action="" method="post" data-for="reset_password">
      <p>Enter your login email and we'll send password reset instructions to that account</p>
      
      <div class="forgot-password-modal">
      
        <input type="email" name="email" required class="forgot-password-modal__email" placeholder="yourlogin@email.com" autocomplete="off" autocapitalize="off" />
        
        <input type="email" name="email_again" class="forgot-password-modal__email-again" title="This is a robot verification field, do not use" placeholder="This is a robot verification field, do not use" autocomplete="off" autocapitalize="off" />
        
        <button type="submit" class="forgot-password-modal__submit button button--medium">Reset Password</button>        
        
      </div>
      
      <div class="forgot-password-modal__message"></div>
      
    </form>
    `);

    const container = modal.getContainer();
    const $message = $(container).find('.forgot-password-modal__message');
    const $btn = $(container).find('forgot-password-modal__submit');

    $(container).on('change', () => {
      $btn.removeAttr('disabled');
      $message.html('');
    });

    $(container).find('form').on('submit', e => {

      e.preventDefault();
      $btn.attr('disabled', true);
      $message.html('Processing...');

      window.apiRequestNoToken('post', '/reset-password', $(e.currentTarget).serialize()).then(r => {
        if (r.type === 'success') {

          setTimeout(() => {
            $message.html(r.message);
          }, 100);

        } else {
          $message.html(r.message);
        }

      });

    });

    modal.open();

  });

}
